export default __webpack_public_path__ + "static/media/Building_Chest.2cdf6da7.png";